import React, { useRef } from 'react';
import Breadcrumbs from '../../../Common/Breadcrumbs';
import PageHeader from '../../../Common/PageHeader';
import CategoriesTable from './CategoriesTable';

const BlogCategoriesPage = () => {
  const categoriesTableRef = useRef<any>(null);

  const handleAddCategory = () => {
    if (categoriesTableRef.current && categoriesTableRef.current.openAddModal) {
      categoriesTableRef.current.openAddModal();
    }
  };

  return (
    <div className="container-fluid" style={{ marginTop: '20px' }}>
      <Breadcrumbs items={[{ label: 'Blog Details' }, { label: 'Categories', active: true }]} />
      <PageHeader
        breadcrumb={null}
        title="Blog Categories Management"
        addNewLabel="Add Category"
        onAddNew={handleAddCategory}
      />
      <CategoriesTable ref={categoriesTableRef} />
    </div>
  );
};

export default BlogCategoriesPage; 